import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { I18nProvider } from "@/contexts/I18nContext";
import { AuthCallback } from "@/components/AuthCallback";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Layout } from "@/components/Layout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ProtocolsList from "@/pages/ProtocolsList";
import ProtocolDetail from "@/pages/ProtocolDetail";
import CreateProtocol from "@/pages/CreateProtocol";
import Referentiel from "@/pages/Referentiel";
import Traductions from "@/pages/Traductions";
import ToValidate from "@/pages/ToValidate";
import Archives from "@/pages/Archives";
import Administration from "@/pages/Administration";
import Aide from "@/pages/Aide";
import Confidentialite from "@/pages/Confidentialite";

function AppRoutes() {
  const location = useLocation();
  // Detect OAuth callback fragment synchronously during render (prevents race condition)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="protocoles" element={<ProtocolsList />} />
        <Route path="protocoles/nouveau" element={<CreateProtocol />} />
        <Route path="protocole/:protocolId" element={<ProtocolDetail />} />
        <Route path="referentiel" element={<Referentiel />} />
        <Route path="traductions" element={<Traductions />} />
        <Route path="a-valider" element={<ToValidate />} />
        <Route path="archives" element={<Archives />} />
        <Route path="administration" element={<Administration />} />
        <Route path="aide" element={<Aide />} />
        <Route path="confidentialite" element={<Confidentialite />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
        <Toaster />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
